import { EntityDescriptor, EntityEditorPage, EntityEditorPageProps } from "@crispico/foundation-react";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { TabRouterPane } from "@crispico/foundation-react/components/TabbedPage/TabbedPage";

export class EquipmentTypeEntityDescriptor extends EntityDescriptor {

    protected customize() {
        this.addFieldDescriptor({ name: "name", type: FieldType.string })
            .addFieldDescriptor({ name: "icon", type: FieldType.string })
            .addFieldDescriptor({ name: "color", type: FieldType.color, colorType: "number" })
            .addFieldDescriptor({ name: "isNonMotorizedEquipment", type: FieldType.boolean })
            .addFieldDescriptor({ name: "qualificationType", type: "QualificationType" })

        this.infoEditor.wrappedComponentClass = class extends EntityEditorPage<EntityEditorPageProps> {

            protected getExtraTabPanes(): (TabRouterPane | null)[] {
                return [
                    ...super.getExtraTabPanes(),
                    this.createOneToManyTabPane("EquipmentTypeTask", "equipmentType")
                ];
            }
        }
    }
}
